import type { CollectedDataOption, OnboardingRequirementCollectBusinessData } from '@onefootprint/request-types';

export const getAllAttributes = (req: OnboardingRequirementCollectBusinessData): CollectedDataOption[] => [
  ...req.missingAttributes,
  ...req.populatedAttributes,
  ...req.recollectAttributes,
];
